<ion-header>
  <ion-toolbar>

    <ion-buttons slot="start">
      <ion-button color="primary" (click)="dismiss()" data-cy="leadDetails-hdr-dismissBtn">
        <!-- <span ion-text class="modal-close" showWhen="ios">Cancel</span> -->
        <ion-icon class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-buttons *ngIf="formData?.guest && formData?.listings && !isMask" slot="end">

      <ion-button color="primary" class="modal-share" *ngIf="plt.is('ios') && plt.is('cordova')" fill="clear"
        (click)="share()">

        <ion-icon class="ios iconSize" name="share-outline"></ion-icon>
      </ion-button>

      <ion-button color="primary" class="modal-share" *ngIf="plt.is('android') && plt.is('cordova')" fill="clear"
        (click)="share()">

        <ion-icon class="ios iconSize" name="share-social-outline"></ion-icon>

      </ion-button>

      <ion-button color="primary" class="exportbutton share" *ngIf="!plt.is('cordova')" fill="clear" (click)="share()"
        data-cy="leadDetails-hdr-exportBtn">
        <ion-label>Export</ion-label>
      </ion-button>

      <ion-button color="primary" fill="clear" (click)="deletePrompt()" data-cy="leadDetails-hdr-deleteBtn">
        <ion-icon class="deleteLead" name="trash"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="color-dark"
      *ngIf="formData?.listings && formData?.listings.address.title && !formData?.guest">Listing Preview</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div class="my-leads-details padding">

    <div *ngIf="formData?.guest">

      <div class="message-area" *ngIf="isMask">
        {{noMicrositeQuestionMessage}}
      </div>

      <div class="profile-card">
        <app-guest-item *ngIf="formData?.guest" [guest]="formData" data-cy="leadDetails-content-profImg">
        </app-guest-item>
        <div class="profile-card-sub">
          <div class="inline-flex">
            <div class="flex-div" *ngIf="isMobilePhone">
              <div *ngIf="!isMask" class="leadName" data-cy="leadDetails-content-name">{{displayName}}</div>
              <div *ngIf="isMask && displayNameWordsLength > 1" class="overlay-mask"
                data-cy="leadDetails-content-name-mask"></div>
            </div>
            <div *ngIf="!isMobilePhone" class="inline-flex">
              <div *ngIf="!isMask" class="leadName" data-cy="leadDetails-content-name">{{displayName}}</div>
              <div *ngIf="isMask && displayNameWordsLength > 1" class="overlay-mask"></div>
            </div>
            <div class="guestVerifiedItem"
              *ngIf="formData?.guest?.verified && formData?.guest?.verified === 'yes' && !formData?.guest?.partialLead">
              <img class="guestVerifiedBadge" src="assets/imgs/Verified-400.png"> Verified
            </div>

            <div class="guestPartialItem" *ngIf="formData?.guest?.partialLead">
              <img class="guestVerifiedBadge" src="assets/imgs/partial-lead.png"> Partial Entry
            </div>

          </div>

          <div *ngIf="formData?.listings" class="guest-visited" data-cy="leadDetails-content-address">
            <!-- <span class="guest-item--left">Listing Address</span> -->
            <div>
              <span *ngIf="formData?.guest?.source.toLowerCase() === 'web'">Filled out the web contact form for
                {{formData?.listings.address.title}} on
                {{formData?.createdAt | date: 'longDate'}}</span>

              <span *ngIf="formData?.guest?.source.toLowerCase() !== 'web'">Visited {{formData?.listings.address.title}}
                on
                {{formData?.createdAt | date: 'longDate'}}</span>
              <br />
            </div>
          </div>
        </div>
      </div>

      <div class="spacer-20"></div>
      <div *ngIf="formData?.guest?.source.toLowerCase() !== 'manual lookup'" class="flex full-width">

        <div *ngIf="(userRole === 'lender' || userRole === 'agentAdmin')" class="leadsDetailField borderBox">
          <div class="standardTitle" data-cy="leadDetails-content-agentNotes-lbl">Agent Notes</div>
          <div class="standardLabel overflow-ellipsis" data-cy="leadDetails-content-agentNotes-value">
            {{formData?.guest?.notes || '--'}}
          </div>
        </div>

        <div *ngIf="userRole === 'agent'" class="leadsDetailField borderBox new-notes" (click)="editNotes($event)">
          <div class="notes-label standardTitle" data-cy="leadDetails-content-agentNotes-lbl">Notes</div>

          <div class="pencil-icon" data-cy="leadDetails-content-notes">
            <span class="pad-left-5">
              <ion-icon name="pencil"></ion-icon>
            </span>
          </div>

          <div class="notes-input">
            <div class="standardLabel overflow-ellipsis" [innerHTML]="formData?.guest?.notes"></div>

          </div>
        </div>

      </div>

      <div *ngIf="formData?.guest?.source.toLowerCase() !== 'manual lookup'" class="flex full-width">

        <div class="leadsDetailField borderBox">
          <div data-cy="leadDetails-content-source-lbl">Source</div>
          <div class="standardLabel" data-cy="leadDetails-content-source-value">{{formData?.guest?.source || '--'}}
          </div>
        </div>
      </div>

      <div class="notes--title" data-cy="leadDetails-content-contactInfo-txt">Contact Info</div>

      <div class="flex full-width">
        <div class="leadsDetailSplit borderBox">
          <div data-cy="leadDetails-content-contactInfo-email-lbl">Primary Email</div>
          <div *ngIf="!isMask" (click)="common.sendEmail(formData?.guest?.email)" class="standardLabel link"
            data-cy="leadDetails-content-contactInfo-email-value">
            {{formData?.guest?.email}}
          </div>
          <div *ngIf="isMask" class="overlay-mask standardLabel link"
            data-cy="leadDetails-content-contactInfo-email-mask"> </div>
        </div>

        <div class="divider"></div>

        <div class="leadsDetailSplit borderBox mobileNumber">
          <div data-cy="leadDetails-content-contactInfo-phone-lbl">Mobile Number</div>
          <div *ngIf="!isMask" class=" standardLabel link" data-cy="leadDetails-content-contactInfo-phone-value"
            (click)="common.openPhoneNumber(formData?.guest?.phoneNumber)">
            {{pn.number.input}}
          </div>
          <div *ngIf="isMask" class="overlay-mask standardLabel link"
            data-cy="leadDetails-content-contactInfo-phone-mask"> </div>
          <!-- <ion-icon color="primary" class="call" name="call-outline"></ion-icon>
          <ion-icon color="primary" class="msg" name="mail-open-outline"></ion-icon> -->
        </div>
      </div>

      <div *ngIf="formData?.questionsAnswers.length" class="notes--title"
        data-cy="leadDetails-content-additionalInfo-txt">Additional Info</div>

      <div *ngFor="let question of formData?.questionsAnswers; let isLastIndex = last">

        <div class="flex full-width">
          <div class="leadsDetailField borderBox" data-cy="leadDetails-content-additionalInfo-title">
            <div class="standardTitle" data-cy="leadDetails-content-additionalInfo-question">{{question.question}}</div>
            <div *ngIf="!question.multipleChoiceOptions || question.multipleChoiceOptions.length === 0"
              class="standardLabel" data-cy="leadDetails-content-additionalInfo-answer">{{question.answer}}</div>
            <div *ngIf="question.multipleChoiceOptions && question.multipleChoiceOptions.length > 0"
              class="standardLabel">{{ getSelectedMultipleChoiceAnswerText(question) }}</div>
          </div>
        </div>
      </div>

      <!-- disclosures -->
      <div *ngIf="formData?.disclosureDoc && formData?.disclosureSelection" class="flex full-width">
        <div class="disclosuresDetailField borderBox" data-cy="leadDetails-content-additionalInfo-title">

          <div class="standardTitle" data-cy="leadDetails-content-additionalInfo-Disclosures">Disclosures</div>
          <div class="standardLabel" data-cy="leadDetails-content-additionalInfo-DisclosuresAnswer">

            <ion-chip *ngIf="formData?.disclosureSelection === 'declineButton'" class="disclosureLockRejected"
              (click)="disclosureClicked()">
              <ion-icon color="primary" src="assets/imgs/document-text-outline.svg"></ion-icon>
              <div class="ion-chip-content">
                <ion-label>{{formData?.disclosureDoc}}</ion-label>
                <ion-label>rejected</ion-label>
              </div>
            </ion-chip>

            <ion-chip *ngIf="formData?.disclosureSelection === 'confirmButton'" class="disclosureLockAccepted"
              (click)="disclosureClicked()">
              <ion-icon color="primary" src="assets/imgs/document-text-outline.svg"></ion-icon>
              <div class="ion-chip-content">
                <ion-label>{{formData?.disclosureDoc}}</ion-label>
              </div>
            </ion-chip>

          </div>
        </div>
      </div>



      <div class="additional-info" *ngFor="let fullItem of fullInfoItems">
        <div class="notes--title">{{fullItem.title}}</div>

        <div class="leadsDetailField borderBox" *ngFor="let item of fullItem.values;let isLastIndex = last">
          <div class="title standardTitle">
            {{item.title}}
          </div>
          <div class="values">
            <div class="standardLabel" *ngFor="let value of item.values">
              <a class="link" (click)="common.openLink(value.link)"
                *ngIf="((fullItem.title === 'Social Accounts' && value.link && !isMask))">{{value.label}}</a>
              <div *ngIf="(fullItem.title === 'Social Accounts' && value.link && isMask)" class="overlay-mask link">
              </div>
              <span *ngIf="!value.link">{{value.label}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="spacer-20"></div>
    </div>


    <div *ngIf="formData?.listings && formData?.listings.address.title">
      <div *ngIf="!formData?.guest">
        <p class="info-message"> {{ pairedAgentInfoMessage }} </p>
        <ion-button class="marketing-services" (click)="goToMarketingServices()" color="primary"
          data-cy="leadDetails-content-listingInfo-marketingServicesBtn">
          <ion-label data-cy="listingDetail-marketingServices-heading-label">Marketing Services</ion-label>
        </ion-button>
      </div>

      <div class="notes--title" data-cy="leadDetails-content-listingInfo-title">Listing Info</div>


      <div class="leadsDetailField borderBox">
        <div class="standardTitle" data-cy="leadDetails-content-listingInfo-address-lbl"> Address </div>
        <div class="standardLabel" data-cy="leadDetails-content-listingInfo-address-value">
          {{formData?.listings.address.title}}</div>
      </div>

      <div class="leadsDetailField borderBox">
        <div class="standardTitle" data-cy="leadDetails-content-listingInfo-price-lbl"> Price </div>
        <div class="standardLabel" data-cy="leadDetails-content-listingInfo-price-value">
          {{common.formatNumber(formData?.listings.listingDetails.price, '$') || '--'}}</div>
      </div>

      <div class="leadsDetailField borderBox">
        <div class="standardTitle" data-cy="leadDetails-content-listingInfo-beds-lbl"> Beds </div>
        <div class="standardLabel" data-cy="leadDetails-content-listingInfo-beds-value">
          {{formData?.listings.listingDetails.beds || '--'}}</div>
      </div>

      <div class="leadsDetailField borderBox">
        <div class="standardTitle" data-cy="leadDetails-content-listingInfo-baths-lbl"> Baths</div>
        <div class="standardLabel" data-cy="leadDetails-content-listingInfo-baths-value">
          {{formData?.listings.listingDetails.baths || '--'}}</div>
      </div>

      <div class="leadsDetailField borderBox">
        <div class="standardTitle" data-cy="leadDetails-content-listingInfo-squareFeet-lbl"> Square Feet </div>
        <div class="standardLabel" data-cy="leadDetails-content-listingInfo-squareFeet-value">
          {{common.formatNumber(formData?.listings.listingDetails.squareFootage) || '--'}}</div>
      </div>

      <div class="thumbnail-wrapper full-width">
        <!--  <listing-image *ngFor="let image of guest.listings.listingImages" [image]="image"></listing-image>-->

        <app-thumbnail *ngFor="let listImage of formData?.listings.listingImages" label="Image Not Found" existLabel=""
          type="property" [property]="listImage">
        </app-thumbnail>

      </div>

      <div *ngIf="(userRole === 'lender' || userRole === 'agentAdmin')">

        <div class="notes--title" data-cy="leadDetails-content-agent-title">Paired Agent Info</div>

        <div class="agentComponent borderBox">
          <app-public-profile-item *ngIf="listingAgent" class="listing-item" [showControls]="false"
            [user]="listingAgent" data-cy="leadDetails-content-agent-agentBox">
          </app-public-profile-item>

        </div>

      </div>

      <div class="spacer-20"></div>

    </div>
  </div>

</ion-content>